"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.replace");

var _axios = _interopRequireWildcard(require("axios"));

var _reduxSaga = require("redux-saga");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _girderClient = _axios.default.create({
  baseURL: "".concat(window.location.origin, "/api/v1")
});

function get(url, config) {
  var source = _axios.CancelToken.source();

  var request = _girderClient.get(url, _objectSpread({
    cancelToken: source.token
  }, config));

  request[_reduxSaga.CANCEL] = function () {
    return source.cancel();
  };

  return request;
}

function post(url, data, config) {
  var source = _axios.CancelToken.source();

  var request = _girderClient.post(url, data, _objectSpread({}, config, {
    cancelToken: source.token
  }));

  request[_reduxSaga.CANCEL] = function () {
    return source.cancel();
  };

  return request;
}

function put(url, data, config) {
  var source = _axios.CancelToken.source();

  var request = _girderClient.put(url, data, _objectSpread({}, config, {
    cancelToken: source.token
  }));

  request[_reduxSaga.CANCEL] = function () {
    return source.cancel();
  };

  return request;
}

function patch(url, data, config) {
  var source = _axios.CancelToken.source();

  var request = _girderClient.patch(url, data, _objectSpread({}, config, {
    cancelToken: source.token
  }));

  request[_reduxSaga.CANCEL] = function () {
    return source.cancel();
  };

  return request;
}

function delete_(url, config) {
  var source = _axios.CancelToken.source();

  var request = _girderClient.delete(url, _objectSpread({}, config, {
    cancelToken: source.token
  }));

  request[_reduxSaga.CANCEL] = function () {
    return source.cancel();
  };

  return request;
}

function updateToken(token) {
  _girderClient.defaults.headers = {
    'Girder-Token': token
  };
}

function setPrefix(prefix) {
  prefix = prefix.trim(); // Ensure leading slash

  if (prefix.length != 0 && prefix[0] !== '/') {
    prefix = "/".concat(prefix);
  } // Remove any trailing slash


  prefix = prefix.replace(/\/+$/, "");
  _girderClient.defaults.baseURL = "".concat(window.location.origin).concat(prefix, "/api/v1");
}

function getBaseURL() {
  return _girderClient.defaults.baseURL;
}

function girderClient() {
  return {
    get: get,
    post: post,
    put: put,
    patch: patch,
    delete: delete_,
    updateToken: updateToken,
    setPrefix: setPrefix,
    getBaseURL: getBaseURL
  };
}

var _default = girderClient;
exports.default = _default;